import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      searchPlaceholder: formatMessage(messages.searchPlaceholder),
      fromDateLabel: formatMessage(messages.fromDateLabel),
      toDateLabel: formatMessage(messages.toDateLabel),
    };
  }, [formatMessage]);
  return translations;
};
export default useTranslations;
